// bss custom
if(location.pathname === '/account/register') {
  function customRF() {
    $(".tt-title-subpages").after(`<div class="text-center bss-container"><div id="rawa-button" class=""><svg class="rawa-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path></svg></div>
<a class="bss-link" href="https://api.whatsapp.com/send/?phone=34614327474" target="_blank">¿Tienes alguna duda? Escríbenos</a></div>`)
  }
  setTimeout(() => {
    customRF()
  }, 300);
   setTimeout(() => {
    $("#loginInputEmail").attr("placeholder", "Tu mejor mail")
  }, 100);
}
let isFirstLoad = true;
let obs = 0;
function handlePLInMiniCart(){
  hidePriceCart();
  setTimeout(() => {
    $(".upcart-product-item").each((_,item) => {
      const cartKey = $(item).attr("id");
      const priceEle = $(item).find(".upcart-item-price");
      priceEle.attr("bss-b2b-final-line-price", "")
      priceEle.attr("bss-b2b-cart-item-key", cartKey)
    })
    $(".upcart-checkout-button").attr("bss-b2b-cart-total-price", "");
    $(".upcart-checkout-button").attr("id", "bss-checkout");
    if(isFirstLoad) {
      isFirstLoad = false;
      document.querySelector("#bss-checkout").addEventListener('click', function (event) {
          disableCheckout();
      }, true);
      document.querySelector(".upcart-checkout-button-container").addEventListener('dblclick', function (event) {
          return false;
      }, true);
    }
    BSS_B2B.cart.fixer(BSS_B2B.shopData, 0, 0);
    BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData)
  }, 300)
}

function hidePriceCart() {
  const styleTag = document.createElement('style');
  styleTag.textContent = '.upcart-item-price { opacity: 0; } #bss-checkout { color: #B51135; pointer-events: none !important}';
  styleTag.id = 'custom-style-tag';
  const checkExist = document.getElementById('custom-style-tag');
  if (!checkExist) {
   document.head.appendChild(styleTag);
  }
}

function showPriceCart() {
  const styleTag = document.getElementById('custom-style-tag');
  if (styleTag) {
    styleTag.remove();
  }
}

function disableCheckout({timeout = 6000}){
  const styleTag = document.createElement('style');
  styleTag.textContent = '#bss-checkout { pointer-events: none !important}';
  styleTag.id = 'custom-style-tag-checkout';
  const checkExist = document.getElementById('custom-style-tag-checkout');
  if (!checkExist) {
   document.head.appendChild(styleTag);
    setTimeout(() => {
      let tag = document.getElementById('custom-style-tag-checkout');
      if(tag) {
        tag.remove();
      }
    }, timeout)
  }
}

// exec open cart drawer
(() => {
  setTimeout(() => {
    const targetNode = document.getElementById('CartPopup');
    if (targetNode) {
  const observer = new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach(mutation => {
          if (targetNode.classList.contains('styles_active__')) {
              handlePLInMiniCart();
          }
      });
  });

  const config = { attributes: true, attributeFilter: ['class'] };
  observer.observe(targetNode, config);
}
  }, 1000)
})();

// Handle change qty. remove item
(() => {
  setTimeout(() => {
    const targetNode = document.querySelector('.upcart-cart-body');
    if(targetNode){
          const observer = new MutationObserver((mutationsList, observer) => {
        mutationsList.forEach(mutation => {
            // remove item
            if(mutation.type === 'attributes'){
            }
            if(mutation.type === 'attributes' && /^\w+:\w+$/.test(mutation.target.id)) {
              setTimeout(() => {
                hidePriceCart();
                handlePLInMiniCart();
              }, 1000)
            }
            // change qty
            if (mutation.type === 'attributes' && mutation.target.classList.contains("upcart-product-quantity-minus")){
              hidePriceCart();
            }
             if (mutation.type === 'attributes' && mutation.attributeName === "src") {
                handlePLInMiniCart()
            }
        });
    });
    
    const config = { attributes: true, childList: true, subtree: true };
    observer.observe(targetNode, config);
    }
  }, 1000)
})()

document.addEventListener("BSS_CP_Calculated", e => {
  setTimeout(() => {
    const checkoutButton = $(".upcart-checkout-button");
    if (checkoutButton.length && checkoutButton.html().includes("Checkout")) {
      checkoutButton.html(`${checkoutButton.html()}`);
    }
    showPriceCart();
  }, 1000)
});

window.addEventListener("cart_changed", () => {
      BSS_B2B.cart.fixer(BSS_B2B.shopData, false, false)
      BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
})

setTimeout(() => {
    function handleButtonClick(e) {
        e.preventDefault();
        const $button = $(this);
        let oldText = $(this).text();
        $button.css({'pointer-events': 'none', 'opacity': '0.6'});
        $button.text("Loading ...");
        setTimeout(() => {
            $button.css({'pointer-events': 'unset', 'opacity': '1'})
            $button.text(oldText);
        }, 2000);
    }
    $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
}, 500)
BSS_B2B.customTriggerCheckoutBtn = function (checkoutBtn) {
    window.location.href = "/checkout";
}